/** @format */

import React from 'react';
import { makeStyles, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import TableHeaderContentCell from '../../../components/Table/TableHeaderContentCell';
import { Moment } from 'moment';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';

interface PaymentForDiscountTableProps {
    payments: Array<{ amount: number; date: Moment | string }>;
    setPayments: (payments: Array<{ amount: number; date: Moment | string }>) => void;
}

const PaymentForDiscountTable = (props: PaymentForDiscountTableProps): React.ReactElement => {
    const useStyle = makeStyles(adescomStyle);
    const classes = useStyle();

    const tableStickyHeader = { root: classes.tableStickyHeader };
    const tableCellRoot = { root: classes.tableCellRootBordered };

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell classes={tableStickyHeader} align="left">
                        <TableHeaderContentCell textAlign="center" title="clients:c.commands" />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} align="left">
                        <TableHeaderContentCell
                            textAlign="center"
                            title="discount:h.date_start"
                            fieldName="dateStart"
                            showSort={false}
                            defaultDirection="desc"
                            searchFieldType="date"
                            timeFormat={false}
                            dateFormat="RRRR-MM-DD"
                        />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} align="left">
                        <TableHeaderContentCell
                            textAlign="center"
                            title="discount:h.name"
                            fieldName="mainname"
                            showSort={false}
                            defaultDirection="desc"
                            searchFieldType="string"
                        />
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {props.payments &&
                    props.payments.map((el: { amount: number; date: Moment | string }) => {
                        return (
                            <TableRow key={el.date + '_' + el.amount}>
                                <TableCell></TableCell>
                                <TableCell>{el.date}</TableCell>
                                <TableCell>{el.amount}</TableCell>
                            </TableRow>
                        );
                    })}
            </TableBody>
        </Table>
    );
};

export default PaymentForDiscountTable;
